import * as React from 'react';
import * as _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { hashHistory } from 'react-router';
import SearchBar from './../SearchBar';
import { GlobalHeaderButtons } from './../PageLayout/GlobalHeaderButtons';
export default function () {
    function onChange1(e) {
        this.setSearchTerm(e.target.value);
    }
    return React.createElement('div', { className: classNames(this.props.className, 'app-header-adj') }, React.createElement(GlobalHeaderButtons, {}), React.createElement('div', { 'className': 'lightbox-header-container' }, React.createElement('div', { 'className': 'lightbox-title-block' }, React.createElement('h1', { 'id': 'PageTitle' }, React.createElement(FormattedMessage, { 'id': 'customers.title' })))), React.createElement(SearchBar, {
        'value': this.state.term,
        'onChange': onChange1.bind(this)
    }));
}